export default "__VITE_ASSET__DjMVC1Pq__"